import React from 'react';

interface SparklineProps {
  data: number[];
  positive: boolean;
  width?: number;
  height?: number;
}

const Sparkline: React.FC<SparklineProps> = ({ data, positive, width = 80, height = 32 }) => {
  if (data.length < 2) return null;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const pad = 2;
  const pts = data.map((v, i) => {
    const x = pad + (i / (data.length - 1)) * (width - pad * 2);
    const y = pad + (1 - (v - min) / range) * (height - pad * 2);
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  }).join(' ');
  const firstPt = `${pad},${(pad + (1 - (data[0] - min) / range) * (height - pad * 2)).toFixed(1)}`;
  const lastPt = `${(width - pad).toFixed(1)},${(pad + (1 - (data[data.length - 1] - min) / range) * (height - pad * 2)).toFixed(1)}`;
  const color = positive ? '#22c55e' : '#f43f5e';
  const fillId = `sf-${positive ? 'g' : 'r'}-${width}`;
  return (
    <svg width={width} height={height} className="overflow-visible">
      <defs>
        <linearGradient id={fillId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.25" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <polygon
        points={`${firstPt} ${pts} ${lastPt} ${(width - pad).toFixed(1)},${height} ${pad},${height}`}
        fill={`url(#${fillId})`}
      />
      <polyline points={pts} fill="none" stroke={color} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
};

export default Sparkline;
